<template>
  <div>
    <v-alert v-if="!adminlogado" type="warning" outlined dense class="mb-4">
      Acesso restrito: faça login como administrador para configurar questionários.
    </v-alert>
    <v-container v-else>
      <v-row justify="center" c>
        <v-col cols="12" sm="8" md="6">
          <v-card class="pa-5">
            <v-text-field v-model="ano" label="Ano" type="number" outlined></v-text-field>
            <v-btn color="primary" @click="buscarQuestionarios" block> Buscar Questionários </v-btn>
            <v-btn color="success" class="mt-2" block @click="novoQuestionario"> Novo Questionário </v-btn>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="questionarios && questionarios.length">
        <v-col cols="12" sm="8" md="6">
          <v-card class="mt-6" elevation="2">
            <v-card-title class="font-weight-bold">Questionários do Ano {{ ano }}</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item
                  v-for="q in questionarios"
                  :key="q.id"
                  @click="editarQuestionario(q)"
                  style="cursor: pointer"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ q.anexo || q.nome || q.titulo || "Sem título" }}</v-list-item-title>
                    <v-list-item-subtitle>ID: {{ q.id }}</v-list-item-subtitle>
                    <v-list-item-subtitle v-if="q.instrumento">Instrumento: {{ q.instrumento }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="white"></v-progress-circular>
          <div class="mt-3">Carregando...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfigurarQuestionario",
  computed: {
    ...mapState({ adminlogado: (state) => state.avaliacao.adminlogado }),
    ...mapGetters({
      anoSelecionado: "avaliacao/anoSelecionado",
      listQuestionario: "avaliacao/listQuestionario",
    }),
  },
  data() {
    return {
      ano: this.anoSelecionado || "",
      questionarios: this.listQuestionario || [],
      loading: false,
    };
  },
  methods: {
    ...mapActions({ requestQuestionarios: "avaliacao/requestQuestionarios" }),
    ...mapMutations({
      setAnoSelecionado: "avaliacao/setAnoSelecionado",
      setSelecionado: "avaliacao/setSelecionado",
    }),
    async buscarQuestionarios() {
      if (!this.ano) {
        this.$emit("erro", "Informe o ano!");
        return;
      }
      this.loading = true;
      try {
        const response = await this.requestQuestionarios({ ano: this.ano });
        this.questionarios = Array.isArray(response) ? response : response.data || [];
        // Salva lista e ano na store
        this.setAnoSelecionado(this.ano);
        this.$emit("questionarios", this.questionarios);
      } catch (e) {
        console.error("Erro ao buscar questionários:", e);
        this.$emit("erro", "Erro ao buscar questionários");
      }
      this.loading = false;
    },
    mounted() {
      // Restaura lista e ano da store ao montar
      if (this.anoSelecionado) {
        this.ano = this.anoSelecionado;
      }
      if (Array.isArray(this.listQuestionario) && this.listQuestionario.length) {
        this.questionarios = this.listQuestionario;
      }
    },
    editarQuestionario(q) {
      this.setSelecionado(q);
      this.$router.push({ name: "EditarQuestionario" });
    },
    novoQuestionario() {
      this.$router.push({ name: "EditarQuestionario" });
    },
  },
};
</script>

<style scoped>
/* Estilos do componente */
</style>
